import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgCelebration({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 33 30"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <defs>
        <circle id="celebration_svg__a" cx={14} cy={14} r={14} />
        <path
          d="M1.93 19.27c-.98.32-2.2-.36-1.88-1.34L5.22.5c.33-.98 2.12-.35 2.85.4l9.62 8.95c.72.73 1.23 1.87.85 2.18L1.93 19.27z"
          id="celebration_svg__c"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <g transform="translate(0 2)">
          <mask id="celebration_svg__b" fill="#fff">
            <use xlinkHref="#celebration_svg__a" />
          </mask>
          <g mask="url(#celebration_svg__b)">
            <g transform="translate(1.98 9.73)">
              <mask id="celebration_svg__d" fill="#fff">
                <use xlinkHref="#celebration_svg__c" />
              </mask>
              <use fill="#FECE00" xlinkHref="#celebration_svg__c" />
              <g stroke="#FB8F23" opacity={0.64} mask="url(#celebration_svg__d)">
                <path d="M21.94 22.77L8.07-7.97m10.8 30.74L5-7.97m10.8 30.74L1.93-7.97m10.8 30.74L-1.14-7.97m10.8 30.74L-4.21-7.97m10.8 30.74L-7.28-7.97m10.8 30.74L-10.35-7.97" />
              </g>
            </g>
          </g>
          <path
            d="M19.77 22.16c-1.52 0-4.56-1.97-7.37-4.78a23.6 23.6 0 01-3.99-5.1c-.89-1.63-.9-2.53-.62-2.8a.73.73 0 01.54-.17c1.53 0 4.56 1.97 7.37 4.78 3.87 3.88 5.3 7.22 4.6 7.91a.73.73 0 01-.53.16z"
            fill="#FFF6CC"
            mask="url(#celebration_svg__b)"
            transform="rotate(-4 14.05 15.74)"
          />
        </g>
        <g transform="translate(2.58 .28)">
          <path
            d="M20.98 3.48a1.74 1.74 0 110-3.47 1.74 1.74 0 010 3.47zm0-2.47a.73.73 0 100 1.46.73.73 0 000-1.46z"
            fill="#FFDD36"
          />
          <circle stroke="#FFE6CE" strokeWidth={0.8} cx={16.94} cy={13.35} r={1} />
          <circle fill="#FFD8C5" cx={24.18} cy={10.41} r={1.19} />
          <circle fill="#FFDD36" cx={23.51} cy={27.21} r={1.19} />
          <path
            d="M21.48 20.87c-.68.21-1.18-.34-1.59-.79-.34-.38-.6-.64-.8-.58a.38.38 0 01-.24-.72c.68-.2 1.18.35 1.59.8.34.37.6.63.8.57.2-.06.27-.43.34-.93.09-.6.2-1.34.87-1.55.68-.21 1.18.34 1.59.79.34.38.6.64.8.58.2-.07.27-.43.34-.94.09-.6.19-1.34.87-1.55.68-.2 1.18.35 1.58.8.35.37.6.63.81.57.2-.06.27-.43.34-.93.09-.6.19-1.35.87-1.55.2-.07.4.05.47.25.06.2-.05.4-.25.47-.2.06-.27.43-.34.93-.09.6-.19 1.35-.87 1.55-.68.21-1.18-.34-1.58-.79-.35-.38-.6-.64-.81-.58-.2.07-.27.43-.34.94-.08.6-.19 1.34-.86 1.55-.68.2-1.19-.35-1.59-.8-.34-.37-.6-.63-.8-.57-.21.06-.28.43-.35.93-.08.6-.18 1.35-.86 1.55z"
            fill="#B7EFFD"
          />
          <path
            d="M13.08 8.56c.09.7-.55 1.1-1.06 1.42-.43.28-.73.48-.7.7.03.2-.12.4-.33.43a.38.38 0 01-.43-.33c-.09-.7.55-1.1 1.06-1.42.43-.27.73-.48.7-.7-.02-.2-.37-.34-.85-.5-.58-.18-1.3-.41-1.38-1.12-.09-.7.54-1.1 1.05-1.42.44-.27.74-.48.71-.7-.1-.55.67-.8.75-.09.1.7-.54 1.1-1.05 1.43-.43.27-.74.48-.71.69.03.21.37.34.86.5.57.18 1.29.42 1.38 1.12v-.01z"
            fill="#FFE6CE"
          />
          <ellipse fill="#B7EFFD" cx={1.6} cy={6.33} rx={1.6} ry={1.61} />
        </g>
      </g>
    </svg>
  );
}

SvgCelebration.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgCelebration.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgCelebration svgRef={ref} {...props} />);
export default ForwardRef;
